import React, { Fragment } from "react";
import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import { useTheme } from "@mui/material/styles";
import { notificationValidations } from "./notificationConstant";
import FormInput from "../Common/FormInputs/MuiTextField";
import EmailRichTextEditor from "./EmailRichTextEditor";
import { useDesignTokens } from "../../theme/useDesignTokens";
import {
  emailBodyFieldRowSx,
  emailFieldRowSx,
  emailFormControlFullWidthSx,
  emailFormControlSx,
  emailFocusOutlineSx,
  emailSectionCardSx,
} from "./emailFormStyles";

const EmailNotificationForm = ({
  messageData = { subject: "", html: "" },
  handleMessageData,
  editorKey = 0,
  onEditorReady,
  onImageUploadError,
}) => {
  const theme = useTheme();
  const { colors } = useDesignTokens();
  const primaryColor = colors?.primary?.main || theme.palette.primary.main;
  const focusOutlineSx = emailFocusOutlineSx(primaryColor);

  return (
    <Fragment>
      <Typography variant="subtitle1" fontWeight={600} sx={{ mt: 2 }}>
        Message
      </Typography>
      <Paper sx={emailSectionCardSx}>
        <Box sx={emailFieldRowSx}>
          <Typography variant="body2" sx={{ fontWeight: 400 }}>
            Subject:
          </Typography>
          <Box sx={emailFormControlSx(theme)}>
            <FormInput
              type="text"
              size="small"
              fullWidth
              placeholder="Enter email subject"
              value={messageData?.subject}
              onChange={(e) => {
                handleMessageData(
                  "subject",
                  e?.target?.value?.substring(0, notificationValidations?.email?.subject?.maxLength)
                );
              }}
              sx={focusOutlineSx}
            />
            <Typography variant="caption" sx={{ display: "block", mt: 0.5 }}>
              {(messageData?.subject?.length > notificationValidations?.email?.subject?.maxLength
                ? notificationValidations?.email?.subject?.maxLength
                : messageData?.subject?.length) +
                "/" +
                notificationValidations?.email?.subject?.maxLength}
            </Typography>
          </Box>
        </Box>
        <Box sx={emailBodyFieldRowSx}>
          <Typography variant="body2" sx={{ fontWeight: 400, pt: { md: 0.5 } }}>
            Email Body:
          </Typography>
          <Box sx={emailFormControlFullWidthSx}>
            <EmailRichTextEditor
              key={`email-body-${editorKey}`}
              value={messageData?.html || ""}
              onChange={(html) => handleMessageData("html", html)}
              onEditorReady={onEditorReady}
              onImageUploadError={onImageUploadError}
            />
          </Box>
        </Box>
      </Paper>
    </Fragment>
  );
};

export default EmailNotificationForm;
